import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"location\">\n  <path id=\"location_location-a\" d=\"M10,3 C7.23571429,3 5,5.191 5,7.9 C5,11.575 10,17 10,17 C10,17 15,11.575 15,7.9 C15,5.191 12.7642857,3 10,3 Z M10,10 C9.08,10 8.33333333,9.216 8.33333333,8.25 C8.33333333,7.284 9.08,6.5 10,6.5 C10.92,6.5 11.6666667,7.284 11.6666667,8.25 C11.6666667,9.216 10.92,10 10,10 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol